<template>
  <div class="viewer"
       :class="{'has-sidebar-visible': sidebarVisible }"
       v-if="manifestData">
    <div class="viewer__main">
      <div class="viewer__main__center">
        <DeepZoom
          :imageURL="currentCanvasEndpoint"
          @toggle-metadata="toggleSidebar"
        >
        </DeepZoom>
      </div>
      <div class="viewer__main__bottom">
        <Thumbnails
          :canvases="mainSequence.canvases"
          @canvas-select="setCanvas"
        >
        </Thumbnails>
      </div>
    </div>
    <div class="viewer__aside">
      <Metadata :metadata="manifestData.metadata"></Metadata>
    </div>

  </div>
  <div v-else class="viewer__empty">
    <h2>{{ message }}</h2>
  </div>
</template>

<script>
import Metadata from '@/components/viewer/Metadata.vue'
import Thumbnails from '@/components/viewer/Thumbnails.vue'
import DeepZoom from '@/components/viewer/DeepZoom.vue'

export default {
  name: 'viewer',
  props: ['manifest'],
  components: { Metadata, Thumbnails, DeepZoom },

  data () {
    return {
      manifestData: null,
      message: 'Loading object data...',
      currentCanvas: null,
      sidebarVisible: true
    }
  },

  computed: {
    currentCanvasEndpoint () {
      if (this.currentCanvas) {
        return this.currentCanvas
                   .images[0]
                   .resource
                   .service['@id']
      } else {
        return false
      }
    },

    mainSequence () {
      return this.manifestData.sequences[0]
    }
  },

  created () {
    if (this.manifest) {
      this.fetchData()
    } else {
      this.message = 'No data to display'
    }
  },

  methods: {
    fetchData () {
      fetch(this.manifest).then((response) => {
        if (response.ok) {
          return response.json()
        }
        throw new Error('Network response was not ok.')
      }).then((data) => {
        this.manifestData = data
        this.message = 'Object data loaded.'
        this.currentCanvas =
          data
            .sequences[0]
            .canvases[0]
      }).catch((error) => {
        console.log('There has been a problem with your fetch operation: ' + error.message)
      })
    },

    setCanvas (canvas) {
      this.currentCanvas = canvas
      console.log(canvas)
    },

    toggleSidebar () {
      this.sidebarVisible = !this.sidebarVisible
    }
  }
}

</script>
<style lang="scss" scoped>
$sidebar-width: 300px;

.viewer {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  min-height: 100%;

  &.has-sidebar-visible {
    .viewer__main {
      flex: 0 0 calc(100% - 300px);
      max-width: 100%;
    }
    .viewer__aside { transform: translateX(0); }
  }

  &__main,
  &__aside {
    border: solid 1px #333;
    transition: transform 0.2s ease-in-out;
  }

  &__aside {
    background-color: #000;
    height: calc(100% - 3.25rem);
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    position: absolute;
    right: 0;
    transform: translateX($sidebar-width);
    width: $sidebar-width;
    z-index: 500;
  }

  &__main {
    display: flex;
    flex-direction: column;
    flex: 3;

    // This seems to fix layout problems but I'm not sure why...
    min-width: 200px;

    &__top,
    &__center,
    &__bottom {
      border: solid 1px #333;
    }

    &__top {
      flex: 0 0 50px;
    }

    &__center {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    &__bottom {
      flex: 0 0 200px;
      max-width: 100%;
      overflow: hidden;
      overflow-x: scroll;
    }
  }

  &__empty {
    align-items: center;
    color: #fff;
    display: flex;
    flex-direction: row;
    height: 100%;
    justify-content: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/viewer/App.vue?40025510